module.exports = __webpack_public_path__ + "static/media/sliderimage1.0ca7015f.png";